import {
  ADD_MEDIA_BUYER_PLAN,
  DELETE_MEDIA_BUYER_PLAN,
  GET_PLANS,
  GET_MEDIA_BUYER_PLAN_FOR_ID,
  HIDE_MEDIA_BUYER_PLANS_LOADER,
  PATCH_PLAN,
  SET_MEDIA_BUYER_PLANS,
  SET_MEDIA_BUYER_PLAN_FOR_ID,
  SHOW_MEDIA_BUYER_PLANS_LOADER,
  GET_FILTERED_MEDIA_BUYER_PLAN,
  ADD_MEDIA_BUYER_PLAN_BY_OFFER,
  DELETE_MEDIA_BUYER_PLAN_BY_OFFER,
  INIT_MEDIA_BUYER_PLANS,
  GET_MEDIA_BUYER_PLANS_PARAMS,
  SET_PLANS_OFFER,
  SHOW_MEDIA_BUYER_PLANS_PARAMS_LOADER,
  HIDE_MEDIA_BUYER_PLANS_PARAMS_LOADER,
  SET_MEDIA_BUYER_PLANS_NESTING,
  GET_MEDIA_BUYER_PLANS_FILTER_DATA,
  SET_MEDIA_BUYER_PLANS_FILTER_DATA,
  HIDE_MEDIA_BUYER_PLANS_FILTER_DATA_LOADER,
  SHOW_MEDIA_BUYER_PLANS_FILTER_DATA_LOADER,
  PATCH_MEDIA_BUYER_PLANS_FILTER_DATA,
  GET_MEDIA_BUYER_PROFIT,
  SET_MEDIA_BUYER_PROFIT,
  PROFIT_LOADING_PROCESS,
  SET_MEDIA_BUYER_PLANS_PROFIT_FILTER_DATA,
  EDIT_CUSTOM_PROFIT_LOCAL,
  CLOSE_CUSTOM_PROFIT_LOCAL,
  ADD_MEDIA_BUYER_VOUCHER,
  UPDATE_MEDIA_BUYER_VOUCHER,
  GET_PAYOUT_CONDITIONS_MEDIA_BUYER,
  SET_PAYOUT_CONDITIONS_MEDIA_BUYER,
  UPDATE_PAYOUT_CONDITIONS_MEDIA_BUYER,
  DELETE_PAYOUT_CONDITIONS_MEDIA_BUYER,
  ADD_PAYOUT_CONDITIONS_MEDIA_BUYER,
  PAYOUT_LOADER_MEDIA_BUYER,
  DELETE_MEDIA_BUYER_VOUCHER,
  TRIGGER_MEDIA_BUYER_VOUCHER,
} from "./actionType";

export const getFilteredPlans = (filter, data) => ({
  type: GET_FILTERED_MEDIA_BUYER_PLAN,
  payload: { filter, data },
});

export const getPlans = data => ({
  type: GET_PLANS,
  payload: data,
});

export const setPlans = payload => ({
  type: SET_MEDIA_BUYER_PLANS,
  payload,
});

export const showPlansDataLoader = () => ({
  type: SHOW_MEDIA_BUYER_PLANS_LOADER,
});

export const hidePlansDataLoader = () => ({
  type: HIDE_MEDIA_BUYER_PLANS_LOADER,
});

export const addMediaBuyerPlan = (plan = {}, data = {}) => ({
  type: ADD_MEDIA_BUYER_PLAN,
  payload: { plan, data },
});

export const setPlansProfitFilterData = payload => ({
  type: SET_MEDIA_BUYER_PLANS_PROFIT_FILTER_DATA,
  payload,
});

export const addMediaBuyerPlanByOffer = plan => ({
  type: ADD_MEDIA_BUYER_PLAN_BY_OFFER,
  payload: { plan },
});

export const deleteMediaBuyerPlan = (id, data = {}) => ({
  type: DELETE_MEDIA_BUYER_PLAN,
  payload: { id, data },
});

export const deleteMediaBuyerPlanByOffer = (id, offerId) => ({
  type: DELETE_MEDIA_BUYER_PLAN_BY_OFFER,
  payload: { id, offerId },
});

export const patchPlan = (offer_id, id, data) => ({
  type: PATCH_PLAN,
  payload: { offer_id, id, data },
});

export const getMediaBuyerPlansById = id => ({
  type: GET_MEDIA_BUYER_PLAN_FOR_ID,
  payload: { id },
});

export const setMediaBuyerPlansForId = payload => ({
  type: SET_MEDIA_BUYER_PLAN_FOR_ID,
  payload,
});

export const initMediaBuyerPlans = (init_data = {}) => ({
  type: INIT_MEDIA_BUYER_PLANS,
  payload: { init_data },
});

/* PARARM */
export const getMediaBuyerPlansParams = payload => ({
  type: GET_MEDIA_BUYER_PLANS_PARAMS,
  payload,
});

export const setPlansOffer = payload => ({
  type: SET_PLANS_OFFER,
  payload,
});

export const showMediaBuyerPlansParamsLoader = payload => ({
  type: SHOW_MEDIA_BUYER_PLANS_PARAMS_LOADER,
  payload,
});

export const hideMediaBuyerPlansParamsLoader = payload => ({
  type: HIDE_MEDIA_BUYER_PLANS_PARAMS_LOADER,
  payload,
});

export const setMediaBuyerPlansNesting = payload => ({
  type: SET_MEDIA_BUYER_PLANS_NESTING,
  payload,
});

/* FILTER DATA */
export const getMediaBuyerPlansFilterData = payload => ({
  type: GET_MEDIA_BUYER_PLANS_FILTER_DATA,
  payload,
});

export const setMediaBuyerPlansFilterData = payload => ({
  type: SET_MEDIA_BUYER_PLANS_FILTER_DATA,
  payload,
});

export const patchMediaBuyerPlansFilterData = payload => ({
  type: PATCH_MEDIA_BUYER_PLANS_FILTER_DATA,
  payload,
});

export const showMediaBuyerPlansFilterDataLoader = () => ({
  type: SHOW_MEDIA_BUYER_PLANS_FILTER_DATA_LOADER,
});

export const hideMediaBuyerPlansFilterDataLoader = () => ({
  type: HIDE_MEDIA_BUYER_PLANS_FILTER_DATA_LOADER,
});

export const getMediaBuyerProfit = payload => ({
  type: GET_MEDIA_BUYER_PROFIT,
  payload,
});

export const setMediaBuyerProfit = payload => ({
  type: SET_MEDIA_BUYER_PROFIT,
  payload,
});

export const setProfitLoadingProcess = () => ({
  type: PROFIT_LOADING_PROCESS,
});

export const editCustomProfit = idx => ({
  type: EDIT_CUSTOM_PROFIT_LOCAL,
  payload: idx,
});

export const closeEditCustomProfit = idx => ({
  type: CLOSE_CUSTOM_PROFIT_LOCAL,
  payload: idx,
});

export const mediaBuyerVoucherUpdateTrigger = data => ({
  type: TRIGGER_MEDIA_BUYER_VOUCHER,
  payload: data,
});

export const addMediaBuyerVoucher = data => ({
  type: ADD_MEDIA_BUYER_VOUCHER,
  payload: data,
});

export const updateMediaBuyerVoucher = (id, data) => ({
  type: UPDATE_MEDIA_BUYER_VOUCHER,
  payload: { id, data },
});

export const deleteMediaBuyerVoucher = (ids) => ({
  type: DELETE_MEDIA_BUYER_VOUCHER,
  payload: { ids },
});

export const addPayoutCondition = data => ({
  type: ADD_PAYOUT_CONDITIONS_MEDIA_BUYER,
  payload: data,
});

export const setPayoutCondition = data => ({
  type: SET_PAYOUT_CONDITIONS_MEDIA_BUYER,
  payload: data,
});

export const getPayoutConditions = data => ({
  type: GET_PAYOUT_CONDITIONS_MEDIA_BUYER,
  payload: data,
});

export const deletePayoutCondition = data => ({
  type: DELETE_PAYOUT_CONDITIONS_MEDIA_BUYER,
  payload: data,
});

export const updatePayoutCondition = data => ({
  type: UPDATE_PAYOUT_CONDITIONS_MEDIA_BUYER,
  payload: data,
});

export const PayoutConditionLoader = () => ({
  type: PAYOUT_LOADER_MEDIA_BUYER,
});